import React from "react";
import Gallery, { ReactImageGalleryItem } from "react-image-gallery";
import "./ImageGallery.css";
import Icon from "../../components/Icon/Icon";
import { stripUrlParams } from "../../../util/UrlHelper";

/*
Usage:
<ImageGallery items={[
  {
    original: 'https://picsum.photos/id/1018/1280/720/',
    thumbnail: 'https://picsum.photos/id/1018/90/90/',
    description: "desc1"
  },
]} />
*/

interface ImageGalleryProps {
    items?: ReactImageGalleryItem[];
    allowDownload?: boolean;
    showThumbnails?: boolean;
}

interface ImageGalleryState {
    currentUrl?: string;
    currentIndex: number;
}

const getInitialUrl = (props: ImageGalleryProps) => {
    if (props.items && props.items.length > 0) {
        return props.items[0].original ? props.items[0].original : "#";
    }
    return "#";
};

class ImageGallery extends React.Component<ImageGalleryProps, ImageGalleryState>
{
    readonly state = { currentIndex: 0, currentUrl: getInitialUrl(this.props) }

    onSlide = (index: number) => {
        if (this.props.items && this.props.items[index] && this.props.items[index].original) {
            this.setState({
                currentUrl: this.props.items[index].original
            });
        }
    }

    // TODO: Direct download not wokring
    // Probarly becuase its linking to another origin
    renderCustomControl = () => {
        return this.props.allowDownload ? <a
            target="blank"
            className={"image-gallery-download-link"}
            href={stripUrlParams(this.state.currentUrl).toString()} download>
            <Icon name="download" className="w-3 h-3" /> Download </a> : null;
    }
    render() {
        if (this.props.items) {
            return <Gallery onSlide={this.onSlide} renderCustomControls={this.renderCustomControl} items={this.props.items} showThumbnails={this.props.showThumbnails} showIndex lazyLoad />;
        }

        return null;
    }
}

export default ImageGallery;
